/**
 * Placeholder da tabela de pessoas (sem colunas de transação).
 */
import {
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  statsTableContainerSx,
  statsTableHeadCellSx,
  statsTableSx,
} from "@/pages/adminInsights/utils/statsTableStyles";

const SKELETON_ROWS = 8;

export default function EcommercePeopleListSkeleton() {
  return (
    <Stack spacing={0}>
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{ ...statsTableContainerSx, borderColor: "primary.light" }}
      >
        <Table size="medium" sx={statsTableSx}>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox" width={48} sx={statsTableHeadCellSx} />
              <TableCell sx={statsTableHeadCellSx}>Nome</TableCell>
              <TableCell sx={statsTableHeadCellSx}>CPF</TableCell>
              <TableCell sx={statsTableHeadCellSx}>Telefone</TableCell>
              <TableCell sx={statsTableHeadCellSx}>Consentimento</TableCell>
              <TableCell sx={statsTableHeadCellSx}>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: SKELETON_ROWS }).map((_, index) => (
              <TableRow key={index}>
                <TableCell padding="checkbox">
                  <Skeleton variant="circular" width={20} height={20} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width="72%" />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width={100} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width={110} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="rounded" width={52} height={26} sx={{ borderRadius: 8 }} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="rounded" width={96} height={36} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Skeleton variant="rounded" height={52} sx={{ mt: 0.5, borderRadius: 1 }} />
    </Stack>
  );
}
